import OurImpactPhone1 from './OurImpactPhone1.svg'
import OurImpactPhone2 from './OurImpactPhone2.svg'
import OurImpactPhone3 from './OurImpactPhone3.svg'

export const Section8Images = {
  OurImpactPhone1,
  OurImpactPhone2,
  OurImpactPhone3,
}
